import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptyMongoApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.REACT_APP_MONGO_API_DOMAIN }),
    keepUnusedDataFor: 10,
    tagTypes: [
        "Views",
        "ActivityCount",
        "ActivityToday",
        "Service",
        "Category",
        "Attachments",
        "TaskCount",
        "Tasks",
        "Task",
        "TaskGens",
        "QuickNote",
    ],
    endpoints: () => ({}),
});
